import { FC, PropsWithChildren } from "react";

const PageHeader: FC<PropsWithChildren> = ({ children }) => (
  <div className="font-bold">
    {children}
  </div>
);

export default PageHeader;
